export const paths = {
  any: '*',
  dashboard: '/dashboard',
  organizations: {
    root: '/organizations',
    details: {
      root: '/organizations/:organizationId',
      tab: '/organizations/:organizationId/:tab',
    },
  },
  projects: {
    root: '/projects',
    new: '/projects/new',
    details: {
      root: '/projects/:projectId',
      tab: '/projects/:projectId/:tab',
    },
    children: {
      details: ':projectId',
    },
  },
  vendors: {
    root: '/vendors',
    details: {
      root: '/vendors/:vendorId',
      tab: '/vendors/:vendorId/:tab',
    },
  },
  login: '/login',
} as const;
